import React from "react";
import cn from "classnames";
import { ReactComponent as ExperienceIcon } from "../icons/experienceIcon.svg";
import { jobsList } from "../../../data/jobsData";

import styles from "../Resume.module.css";
import ItemList from "../ItemList";

export default function Experience({ experienceText }) {
    return (
        <div className={cn(styles.experience)}>
            <div className={cn(styles.title)}>
                <ExperienceIcon />
                <h4>{experienceText}</h4>
            </div>
            <div className={cn(styles.resumeItems)}>
                <ItemList itemList={jobsList} />
            </div>
        </div>
    );
}
